import { ValueOf } from "type-fest";

export const WorkbenchDiffStatus = {
  ADDED: "ADDED",
  MODIFIED: "MODIFIED",
  DELETED: "DELETED",
  UNMODIFIED: "UNMODIFIED",
} as const;
export type WorkbenchDiffStatus = ValueOf<typeof WorkbenchDiffStatus>;
